import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import * as Yup from 'yup'
import CustomTable from '@/product/components/molecules/CustomTable'
import { Button } from '@material-ui/core'
import CustomDialog from '@/product/components/organisms/Dialog'
import DashboardLayout from './DashboardLayout'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ProductContext from '@/product/context/seller/product/productContext'
import AuthContext from '@/product/context/auth/authContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
const PrivateAuction = (props) => {
    const [isLoading, setIsLoading] = useState(true)
    const [changeStatus, setChangeStatus] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [detail, setDetail] = useState({})
    const productContext = useContext(ProductContext)
    const { user } = useContext(AuthContext)

    const alertContext = useContext(AlertContext)
    const dynamicContext = useContext(DynamicContext)
    const { setAlert } = alertContext
    const { getDynamicTableValues, dynamicTableValue } = dynamicContext
    const {
        getProjectAccessRequest,
        all_project_access_req,
        projectAccessReqStatus,
        responseStatus: productResponseStatus,
        clearResponse: clearResponseProduct,
    } = productContext

    // USER

    const userFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            action: 0,
            searchterm: '',
            table: 'project_access_request',
            // group_id: 0,
            filters: {
                userid: {
                    value: 0,
                    type: 'in',
                    field: 'par.requested_user_id',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'p.title',
                },
                approved: {
                    value: '',
                    type: 'in',
                    field: 'par.approved_status',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    customTable: 'custom_users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'requested_user_id',
                },
                {
                    baseTable: 'projects',
                    customTable: 'custom_projects',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'project_id',
                },
            ],
        },
        onSubmit: (values) => {
            setIsLoading(true)

            getDynamicTableValues(values, 'registedUser')
        },
    })

    useEffect(() => {
        console.log('all_group_users', dynamicTableValue)
        if (dynamicTableValue && dynamicTableValue.from === 'registedUser') {
            setTableBody(dynamicTableValue.records.length ? dynamicTableValue.records : [])
            setIsLoading(false)
        }
    }, [dynamicTableValue])

    const onClickEdit = (id, secondaryID, type) => {
        console.log('onClickEdit', id, type)
        if (all_project_access_req && all_project_access_req.records.length) {
            let userDetail = all_project_access_req.records.find((ele) => ele.id == id)
            setDetail(userDetail)
            if (type === 'edit') {
                formikSelection.values.approved = 1
                formikSelection.values.auto_approved = 1
                formikSelection.values.approved_status = 'approved'
            } else {
                formikSelection.values.approved = 0
                formikSelection.values.auto_approved = 0
                formikSelection.values.approved_status = 'rejected'
            }
            setChangeStatus(true)
        }
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'recommend',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Approve user',
                disabledField: 'approved',
                disabledType: true,
            },
            {
                buttonType: 'cancel',
                clickType: 'cancel',
                onclick: onClickEdit,
                tooltipTitle: 'Reject User',
            },
        ]
        return actionPush
    }
    useEffect(() => {
        if (user && user.id) {
            setTableBody([])
            console.log(user.id, 'user values')
            setIsLoading(true)
            userFormik.values.page = 1
            userFormik.values.filters.userid.value = user?.id
            userFormik.values.filters.searchterm.value = ''
            userFormik.values.filters.approved.value = 0
            userFormik.values.searchterm = ''
            console.log(userFormik.values, 'valkkk')

            getDynamicTableValues(userFormik.values, 'registedUser')
        }

        /*  return () => {
            setTableBody([])
        }*/
    }, [user])

    const tableValues = [
        {
            field: 'projects_id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },

        {
            field: 'projects_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Offer Title',
        },
        {
            field: 'projects_market_status',
            type: 'capitalize',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Lot Status',
        },
        {
            field: 'request_notes',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Request Notes',
            tooltipTitle: 'request_notes',
            compressString: true,
            condition: true,
        },
        {
            field: 'approved_status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'approve_notes',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Approve/Reject Notes',
            tooltipTitle: 'approve_notes',
            compressString: true,
            condition: true,
        },
        // {
        //     field: 'action',
        //     type: 'button',
        //     clickID: 'id',
        //     sort: false,
        //     firstChild: false,
        //     disablePadding: false,
        //     label: 'Action',
        //     isMultiple: getMultipleAction(),
        // },
    ]

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const searchInfo = {
        formik: userFormik,
        data: [
            {
                label: 'Offer Title',
                placeholder: 'Enter Offer Title',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
                filter: true,
            },
            {
                label: 'Status',
                placeholder: 'Enter status',
                class: 'col-sm-6 col-12',
                filter: true,
                type: 'select',
                options: [
                    { value: 'pending', show: 'Pending' },
                    { value: 'approved', show: 'Approved' },
                    { value: 'rejected', show: 'Rejected' },
                ],
                name: 'approved',
            },
        ],
    }

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            approved: 0,
            auto_approved: 0,
            onlyBidding: true,
            project_id: 0,
            approved_status: '',
        },
        onSubmit: (values) => {
            if (detail.id > 0) {
                console.log('values', values)
                values.id = detail.id
                values.project_id = detail.project_id
                values.requested_user_id = detail.requested_user_id
            }
        },
    })

    return (
        <DashboardLayout title={'IOI Request'}>
            <div className="addUserModal">
                <div className="fspBody">
                    {/* <form onSubmit={formik.handleSubmit} autoComplete="nofill"> */}
                    <CustomSearch searchInfo={searchInfo} formik={userFormik} />

                    {/* <div className="row">{Object.values(mapData(searchInfo))}</div>
                    <PrimaryButton label="search" onClick={userFormik.handleSubmit} /> */}

                    {}
                    {isLoading ? (
                        <div>Loading....</div>
                    ) : (
                        <CustomTable
                            formik={userFormik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={[]}
                            allData={dynamicTableValue}
                            isLoading={isLoading}
                            loadingTemplate={'table'}
                            changeTableFunction={getDynamicTableValues}
                        />
                    )}
                </div>
            </div>
            <CustomDialog
                title={'Change user status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    Are you sure you want to change of User {detail.users_email} to{' '}
                    {formikSelection.values.approved ? 'Approved' : 'Rejected'}
                </h5>

                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form onSubmit={formikSelection.handleSubmit} autoComplete="nofill">
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </DashboardLayout>
    )
}

export default PrivateAuction
